/** Append display width for tiny.pictures parking photos from the API. */
export function withParkingPhotoWidth(url: string, width: number): string {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}width=${width}`;
}
